import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import queryString from 'query-string';

import { LoadingOverlay } from '@mantine/core';

import { MenuManagementProvider } from 'context/MenuManagementProvider';
import { useAuth } from 'hooks/useAuth';
import { useMenuManagement } from 'hooks/useMenuManagement';

import { LOCATION_PATH, MENU_PATH } from 'constants/path';

import MenuInformation from 'components/MenuManagement/MenuInformation';
import { MenuPreview } from 'components/MenuManagement/MenuPreview';

export default function PreviewMenu() {
  return (
    <MenuManagementProvider>
      <PreviewContent />
    </MenuManagementProvider>
  );
}

function PreviewContent() {
  const [previewMenu, setPreviewMenu] = useState(null);
  const [hasCalledOnce, setHasCalledOnce] = useState(false);
  const { merchants } = useAuth();
  const { getSingleCubohMenu, singleMenu, fetchAvailableClassifications } = useMenuManagement();
  const navigate = useNavigate();
  const location = useLocation();
  const { restaurantId } = useParams();

  const queryParams = queryString.parse(location.search);
  const menuData = singleMenu?.data?.[queryParams.merchantId]?.[0];

  useEffect(() => {
    if (queryParams.merchantId) {
      if (queryParams.menuId && !hasCalledOnce) {
        setHasCalledOnce(true);
        const companyId = merchants[queryParams.merchantId].companyID;
        getSingleCubohMenu(companyId, queryParams.merchantId, queryParams.menuId);
        fetchAvailableClassifications(companyId);
      }
    } else {
      navigate(`${LOCATION_PATH}/${restaurantId}${MENU_PATH}`);
    }
  }, [queryParams]);

  useEffect(() => {
    if (menuData && !previewMenu) {
      setPreviewMenu({
        menuUuid: menuData.uuid,
        merchantID: menuData.merchantId,
        companyID: menuData.companyId,
        itemHours: menuData.itemHours,
        specialHours: menuData.specialHours,
        deliveryHours: menuData.deliveryHours,
        deliveryMatchesPickup: menuData.deliveryMatchesPickup,
        menuSource: menuData.menuSource,
      });
    }
  }, [singleMenu]);

  if (!previewMenu) {
    return <LoadingOverlay visible />;
  }

  return (
    <MenuInformation setPreviewMenu={setPreviewMenu} previewMenu={previewMenu}>
      <MenuPreview />
    </MenuInformation>
  );
}
